/**
 * @file annotationFind.saga.js
 * @description
 *
 * @copyright veriome labs, llc.  - all rights reserved.
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.md', which is part of this source code package.
 *
 * @author don michael
 * @since Sep 19, 2023 14:52
 */
import { call, put, takeLatest } from 'redux-saga/effects';
import axiosClient from 'src/services/axiosClient.js';

import {
    annotationEditOpenDialogSet,
} from 'src/store/actions/documentAnnotator/documentAnnotatorDb.actions';

import {
    DOCUMENT_ANNOTATOR_ANNOTATION_FIND_REQUEST,
    annotationFindSuccess,
    annotationFindFailure,
} from 'src/store/actions/documentAnnotator/documentAnnotatorDb.actions';

import { dataLoadingSet } from 'src/store/actions/global.actions';
import handleSagaErrors from 'src/store/sagas/handleSagaErrors';

function callApi(payload) {
    const url = '/documentAnnotator/annotationFind';

    const baseUrl = import.meta.env.VITE_APP_API_BASE_URL;

    const config = {
        method: 'post',
        baseURL: baseUrl,
        url,
        data: {
            annotationId: payload,
        },

    };

    return new Promise((resolve, reject) => {
        axiosClient(config)
            .then((response) => {
                resolve(response.data);
            })
            .catch((err) => {
                reject(err);
            });
    });
}

function* requestSaga(action) {

    try {
        yield put(dataLoadingSet(true));

        const resp = yield call(callApi, action.payload);

        yield put(dataLoadingSet(false));
        yield put(annotationFindSuccess(resp.payload));
        yield put(annotationEditOpenDialogSet(true));

    } catch (error) {
        yield put(annotationFindFailure(error));
        handleSagaErrors(error);
    } finally {
        yield put(dataLoadingSet(false));
    }


}

export default function* requestMonitor() {
    yield takeLatest(DOCUMENT_ANNOTATOR_ANNOTATION_FIND_REQUEST, requestSaga);
}
